import { useEffect } from "react";
import type { EventEmitter } from "@/shared/eventEmiters/EventEmitter";

export const useEventSubscription = (
	eventEmitter: EventEmitter,
	event: string,
	handler: (data: any) => void,
) => {
	useEffect(() => {
		eventEmitter.on(event, handler);

		return () => {
			eventEmitter.off(event, handler);
		};
	}, [eventEmitter, event, handler]);
};
